import { apiClient } from '@/api/api'
import type { GiftRecipient, Person, PersonPatch, PersonPayload } from '@/types/people'

export const getPeople = async (): Promise<Person[]> => {
  const response = await apiClient.get<{ profiles: Person[] }>('/user-profile/profiles')
  return response.data.profiles ?? []
}

export const createPerson = async (payload: PersonPayload): Promise<Person> => {
  const response = await apiClient.post<{ profile: Person }>('/user-profile/profiles', payload)
  return response.data.profile
}

export const updatePerson = async (id: number, payload: PersonPayload): Promise<Person> => {
  const response = await apiClient.put<{ profile: Person }>(`/user-profile/profiles/${id}`, payload)
  return response.data.profile
}

/** BE-150 — partial write; `null` clears a field, an absent one is untouched. */
export const patchPerson = async (id: number, patch: PersonPatch): Promise<Person> => {
  const response = await apiClient.patch<{ profile: Person }>(`/user/gift-persons/${id}`, patch)
  return response.data.profile
}

export const deletePerson = async (id: number): Promise<void> => {
  await apiClient.delete(`/user-profile/profiles/${id}`)
}

/** BE-138 — the gift banner's people with their taste counts. */
export const getGiftRecipients = async (): Promise<GiftRecipient[]> => {
  const response = await apiClient.get<{ items: GiftRecipient[] }>('/user/gift-recipients')
  return response.data.items ?? []
}
